import { render, staticRenderFns } from "./FlexibleDetailTab4.vue?vue&type=template&id=687dff81&scoped=true"
import script from "./FlexibleDetailTab4.vue?vue&type=script&lang=js"
export * from "./FlexibleDetailTab4.vue?vue&type=script&lang=js"
import style0 from "./FlexibleDetailTab4.vue?vue&type=style&index=0&id=687dff81&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687dff81",
  null
  
)

export default component.exports